module.exports = __webpack_public_path__ + "img/img3.08fc388.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img3.png
// module id = m22b
// module chunks = 2